export function moverAreaLateral(estado) {
  return {
    type : estado === 'CONTRAIDO' ? 'AREALATERAL_EXPANDIR' : 'AREALATERAL_CONTRAIR'
  }
}